import { t } from "i18next";
import type { AnniversaryEvent, Person } from "@/services/api";

export const getAnniversaryText = (
  person: Person | null | undefined,
  record?: AnniversaryEvent,
): string => {
  if (!person || person.anniversaries.length === 0) {
    return "";
  }

  if (!record?.description) {
    return "";
  }

  const firstName = person?.firstName ?? "";
  const lastName = person?.lastName ?? "";

  return t("calendarPage.anniversaryText", {
    firstName,
    lastName,
    anniversaryType: record.description,
  });
};
